const urlMaxLength = 2000

const dashboardAuthorizerConfig = {
  validTypes: ['speaker', 'sponsor', 'exhibitor', 'homeland'],
  validRegions: ['NORTH_AMERICA_EUROPE', 'ASIA_PACIFIC', 'LATIN_AMERICA', 'AFRICA', 'MENA'],
}

const dashboardStateTypes = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  REVOKED: 'REVOKED',
}

const formsConfig = {
  largeTextBox: 1000,
  mediumTextBox: 550,
  smallTextBox: 254,
}

const callForPresentationsConfig = {
  supportedLanguages: ['en', 'fr', 'de', 'it', 'es', 'pt', 'ja', 'hu', 'ko', 'zh', 'zh-hans', 'zh-Hant'],
}

const proposalTransitionIds = {
  beta: 'initial-74-219982c0-12f9-11ef-ae39-bda99d568b45',
  integration: 'initial-74-219982c0-12f9-11ef-ae39-bda99d568b45',
  www: 'initial-74-219982c0-12f9-11ef-ae39-bda99d568b45',
}

const sponsorSubmitTransitionIds = {
  integration: 'initial-78-f75f3cf0-9180-11ef-8b3d-a180798d3a11',
  beta: 'initial-78-f75f3cf0-9180-11ef-8b3d-a180798d3a11',
  www: 'initial-78-f75f3cf0-9180-11ef-8b3d-a180798d3a11',
}

const exhibitorSubmitTransitionIds = {
  integration: 'initial-0-fbdc6d50-98f5-11ed-a23d-a501f5dfe716',
  beta: 'initial-0-fbdc6d50-98f5-11ed-a23d-a501f5dfe716',
  www: 'initial-0-fbdc6d50-98f5-11ed-a23d-a501f5dfe716',
}

const homelandSubmitTransitionIds = {
  integration: 'initial-77-6366eb30-63e3-11ef-8a7a-2798c58c96f2',
  beta: 'initial-77-6366eb30-63e3-11ef-8a7a-2798c58c96f2',
  www: 'initial-77-6366eb30-63e3-11ef-8a7a-2798c58c96f2',
}

const sessionStates = {
  DRAFT: 'DRAFT',
  WORKFLOW: 'WORKFLOW',
  PUBLISHED: 'PUBLISHED',
  SUBMITTED: 'SUBMITTED',
  DECLINED: 'DECLINED',
  ACCEPTED: 'ACCEPTED',
  EDITABLE: 'EDITABLE',
  TRASHED: 'TRASHED',
}

// Incoming Proposal, Rejected Proposal, Accepted Proposal, Signed Proposal, Submitted Session
const sessionWorkflowStates = {
  '0-9476c590-194e-11ef-912b-393ea483e1e6': 'SUBMITTED', // qa4
  '74-a0cb39f0-12f7-11ef-ae39-bda99d568b45': 'SUBMITTED', // www
  '1-9a8ead80-194e-11ef-912b-393ea483e1e6': 'DECLINED', // qa4
  '73-8a062bf0-d1ff-11ee-a55f-f11b96d40b80': 'DECLINED', // www
  '75-b7a942c0-12f7-11ef-ae39-bda99d568b45': 'ACCEPTED', // www
  '2-9cb2c600-194e-11ef-912b-393ea483e1e6': 'ACCEPTED', // qa4
  '3-a82dc4d0-194e-11ef-912b-393ea483e1e6': 'EDITABLE', // qa4
  '76-c862e080-12f7-11ef-ae39-bda99d568b45': 'EDITABLE', // www
  '77-29c7a310-63e3-11ef-8a7a-2798c58c96f2': 'SUBMITTED', // www & qa4, Skip Proposal (Homelands)
  '4-af7971d0-194e-11ef-912b-393ea483e1e6': 'SUBMITTED', // qa4 functionally the same as below
  '69-0279ab00-535f-11ed-89f1-b5840d7c88e8': 'SUBMITTED', // www Assign for Review
  '78-e0c6c8a0-9180-11ef-8b3d-a180798d3a11': 'EDITABLE', // Initial Review
}

const exhibitors = {
  familysearch: '0000017c-dcfc-d148-a77d-dcffcf810000',
}

const mainStageUpload = {
  url: 'https://rootstech.portal.massive.io/',
}

const videoTypes = {
  live: 'WebinarVideoProvider',
  youtube: 'YoutubeVideoProvider',
  prerecorded: 'HostedVideoProvider',
}

const sessionLocationMap = {
  'Pre-recorded': 'ONLINE',
  'In Person Only': 'IN_PERSON',
  Panel: 'IN_PERSON',
  Workshop: 'IN_PERSON',
  'Live Webinar': 'ONLINE',
}

const attachmentWorkflow = {
  draft: 'initial-1-f5931920-8d9f-11f0-9e82-b3d733cd0b67',
  review: '1-0-07aedef0-8da0-11f0-9e82-b3d733cd0b67',
  state: {
    draft: '1-e8971fa0-8d9f-11f0-9e82-b3d733cd0b67',
    review: '0-faa55c00-4478-11ef-9bea-419f3a72f364',
  },
}

export {
  urlMaxLength,
  dashboardAuthorizerConfig,
  dashboardStateTypes,
  formsConfig,
  callForPresentationsConfig,
  proposalTransitionIds,
  sponsorSubmitTransitionIds,
  exhibitorSubmitTransitionIds,
  homelandSubmitTransitionIds,
  sessionStates,
  sessionWorkflowStates,
  sessionLocationMap,
  exhibitors,
  mainStageUpload,
  videoTypes,
  attachmentWorkflow,
}
